import { render, staticRenderFns } from "./uploadURL-editor.vue?vue&type=template&id=186d5f2a&scoped=true&"
import script from "./uploadURL-editor.vue?vue&type=script&lang=js&"
export * from "./uploadURL-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186d5f2a",
  null
  
)

export default component.exports